import { Exception } from '@opentelemetry/api'

import { MetaAttributes } from '../../metas'

export interface TrackErrorOptions {
  metas?: MetaAttributes
}

export interface ExceptionsAPI {
  traceError: (value: Error, options?: TrackErrorOptions) => void
}

export enum ExceptionType {
  CUSTOM_EXCEPTION = 'customException',
}

export const defaultExceptionType = ExceptionType.CUSTOM_EXCEPTION

export type APIEvent = Exception

export type TransportItemPayload<P = APIEvent> = P

export interface CustomItem<P = APIEvent> {
  payload: TransportItemPayload<P>
  meta: MetaAttributes
}
